import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const LOT_BASE = "/lots";
const buildUrl = (endpoint) => LOT_BASE + endpoint;

const stockApiSlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        getLots: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: 'Lots' }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getBatches', 'Batch')
        }),
        getOrdersFromLot: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`/orders?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: 'Lots' }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getBatches', 'Batch')
        }),
        getLot: builder.query({
            query: id => buildUrl(`/${id}`),
            providesTags: (result, error, arg) => [{ type: 'LotsSingle'}]
        }),
        addLot: builder.mutation({
            query: batchInfo => ({
                url: buildUrl(`/create`),
                method: 'POST',
                body: batchInfo,
            }),
            invalidatesTags: (result, error, arg) => [{type: 'Lots'}, { type: 'Stock' }, { type: 'ProductsSingle'}, { type: 'StockForProduct'}],
        }),
    })
});

export const { 
    useGetLotsQuery,
    useGetOrdersFromLotQuery,
    useGetLotQuery,
    useAddLotMutation
 } = stockApiSlice;
